/* -------------------------------------------------------------------------- */
/*                               Schema Geofences                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const geofence = new schema.Entity('geofences', {}, { idAttribute: 'geofenceId' });
export const geofences = new schema.Array(geofence);
